<template>
   <a-select :allowClear="allowClear" @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
     <a-icon slot="suffixIcon" type="caret-down" />
     <a-select-option v-for="item in years" :key="item" :disabled="disabledList.indexOf(item) != -1" :label="item+suffix" :value="item">{{item}}{{suffix}}</a-select-option>
   </a-select>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'ptYearSelect',
    props:{
      placeholder:{
        type:String,
      },
      allowClear:{
        type:Boolean,
        default:true,
      },
      showNext:{
        type:Boolean,
        default: false,
      },
	    suffix:{
				type:String,
		    default:''
	    },
      value:{
        type: [Object, Array] | String,
      },
      disabledList:{
        type:Array,
        default:()=>{return []}
      },
      startYear:{
        type:Number,
        default:2016,
      }
    },
    data() {
      return {
        input:this.value,
        years:[],
      }
    },
    watch:{
      value (val) {
        this.input = val
      },
      input(val){
        this.$emit('input',val)
      }
    },
    mounted(){
      this.initYear()
    },
    methods:{
      initYear(){
        let nowYear = moment().format('YYYY')
        let year = parseInt(nowYear);
        if(this.showNext){
          year = year + 1;
        }
        let arr = []
        for(let i = year;i >= this.startYear ;i--){
          arr.push(i)
        }
        this.years = arr;
      },
      changeValue(value){
        this.$emit('input',value)
      }
    }
  }
</script>

<style scoped lang="less">

</style>